import { memo, useCallback } from "react";

import { cn } from "@/lib/chillnn/cn";
import { useCopyToClipboard } from "@/lib/react-use/use-copy-to-clipboard";

import { notifyUserEventInfo } from "@/components/features/side-effect/notify-user-event-info";

import { Button } from "@/components/ui/button/button";
import ContentCopyIcon from "@/components/ui/icon/content-copy";
import OpenInNew from "@/components/ui/icon/open-in-new";

type Props = {
	url: string;
	textColor?: "brand" | "link";
};

export const LinkButton = memo(({ url, textColor = "brand" }: Props) => {
	const { copy } = useCopyToClipboard();
	const textColorClassName = textColor === "brand" ? "text-brand" : "text-link-400";

	const handleClick = useCallback(() => {
		window.open(url, "_blank");
	}, [url]);

	const handleCopy = useCallback(() => {
		copy(url);
		notifyUserEventInfo({
			title: "URLをコピーしました",
		});
	}, [copy, url]);

	return (
		<div className="flex items-start gap-x-2">
			<button type="button" onClick={handleClick} className="min-w-0 cursor-pointer text-left hover:underline">
				<span className={cn("break-all text-base", textColorClassName)}>{url}</span>
				<OpenInNew size="sm" className="ml-1 inline-block align-middle" />
			</button>
			<Button type="button" variant="input-ish" size="icon" onClick={handleCopy} tooltip="URLをコピーする">
				<ContentCopyIcon size="sm" />
			</Button>
		</div>
	);
});

LinkButton.displayName = "LinkButton";
